import { Link } from "@mui/material";
import { useMap } from "react-leaflet";
import { useTranslation } from "react-i18next";

import { useStudyArea } from "hooks/studyAreaHooks";

interface Props {
  uuid?: string;
}

export function ZoomToStudyArea(props: Props) {
  const { uuid } = props;
  const map = useMap();

  const { t } = useTranslation();
  const { data: studyArea } = useStudyArea(uuid || "", {
    enabled: !!uuid,
  });

  function zoomToStudyArea() {
    if (studyArea) {
      map.fitBounds(studyArea.geometry_4326.getBounds());
    }
  }

  return (
    <>
      {studyArea && (
        <Link onClick={zoomToStudyArea}>{t("label.resetToStudyARea")}</Link>
      )}
    </>
  );
}
